import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { LOAN_DELETE_FINANCIAL_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class DeleteLoanFinancial extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  body = {};

  url = LOAN_DELETE_FINANCIAL_URL;

  constructor(applicantId, finAnalysisId, financialId) {
    super();
    const paramList = [applicantId, finAnalysisId, financialId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
